import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
  ButtonGroup,
  DialogTitle as MuiDialogTitle,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  // backgroundColor: theme.palette.secondary.main,
  // textAlign: 'center'
  // borderBottom: '1px solid #c9c9c9'
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  // color: theme.palette.primary.main
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
  "&:hover": {
    color: theme.palette.secondary.main,
  },
}));

const StyledDialog = styled(Dialog)(({ theme, bigHeight }) => ({
  "& .MuiDialog-paper": {
    minHeight: bigHeight ? "90vh" : "auto",
    maxHeight: bigHeight ? "95vh" : "auto",
  },
}));

const CustomDialogTitle = ({ children, noWrap, onClose, ...other }) => {
  return (
    <StyledDialogTitle disableTypography {...other}>
      <StyledTypography variant="h6" noWrap={noWrap}>
        {children}
      </StyledTypography>
      {onClose ? (
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      ) : null}
    </StyledDialogTitle>
  );
};

function RenderModal(props) {
  const {
    handleClose,
    size,
    title,
    handleSubmit,
    btnActionTitle,
    btnCancelTitle,
    open,
    disabledAction,
    bigHeight,
    noWrap,
    forcedZindex,
    removeDropClick,
    overrideDialogActions,
  } = props;

  let zindexStyle = {};

  forcedZindex && (zindexStyle = { zIndex: 1300 });

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth={size}
      bigHeight={bigHeight}
      disableBackdropClick={removeDropClick}
      style={zindexStyle}
    >
      <CustomDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        noWrap={noWrap}
      >
        {title}
      </CustomDialogTitle>

      <DialogContent sx={{ padding: "3%" }}>{props.children}</DialogContent>

      {overrideDialogActions ? (
        overrideDialogActions()
      ) : (
        <DialogActions>
          <ButtonGroup>
            {btnActionTitle && (
              <Button
                variant="contained"
                size="large"
                color="secondary"
                onClick={handleSubmit}
                disabled={disabledAction || false}
              >
                {btnActionTitle}
              </Button>
            )}
            {btnCancelTitle && (
              <Button
                variant="outlined"
                size="large"
                color="secondary"
                onClick={handleClose}
              >
                {btnCancelTitle}
              </Button>
            )}
          </ButtonGroup>
        </DialogActions>
      )}
    </StyledDialog>
  );
}

RenderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  forcedZindex: PropTypes.bool,
  bigHeight: PropTypes.bool,
  size: PropTypes.string,
  handleClose: PropTypes.func,
  noWrap: PropTypes.bool,
  title: PropTypes.string,
  handleSubmit: PropTypes.func,
  btnActionTitle: PropTypes.string,
  btnCancelTitle: PropTypes.string,
  disabledAction: PropTypes.bool,
  overrideDialogActions: PropTypes.func,
  children: PropTypes.node,
};

export default RenderModal;
